const programAvailabilityTranslations = {
  title: "Fill Your Form.",
  description:
    "Kindly fill your form, in order to start creating your nutrition & workout program.",
  action: "Fill Form",
};

export default programAvailabilityTranslations;
